





















































































































































import { Vue, Component, Mixins } from 'vue-property-decorator';

import MyList from '@/mixins/list';

import SelectStadium from '@/components/selectstadium.vue';

@Component({
  components: {
    SelectStadium,
  },
})
export default class extends Mixins(MyList) {
  dispatchType = 'privatetel/list';

  columns: any[] = [
    { title: '编号', dataIndex: 'id' },
    { title: '呼叫人', dataIndex: 'caller_mobile' },
    { title: '被叫人', dataIndex: 'callee_mobile' },
    { title: '隐私号码', dataIndex: 'private_num' },
    { title: '标识', dataIndex: 'subscription_id' },
    { title: '场馆', dataIndex: 'stadium_name' },
    { title: '状态', scopedSlots: { customRender: 'bind_status' } },
    { title: '绑定时间', dataIndex: 'created_time' },
    { title: '解绑时间', dataIndex: 'updated_time' },
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;

  mounted() {
    this.loadData();
  }
}
